import { Box, Field, InputGroup, NumberInput } from "@chakra-ui/react";
import React from "react";
import useThemeColors from "../../hooks/useThemeColors";

interface Props {
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  label?: string;
  error?: string;
  startElement?: React.ReactNode;
  min?: number;
  max?: number;
  placeholder?: string;
  w?: string;
  minW?: string;
  maxW?: string;
  invalid?: boolean;
  required?: boolean;
  info?: React.ReactNode;
}

const CustomNumberInput: React.FC<Props> = ({
  value,
  onChange,
  onBlur,
  label,
  error,
  startElement,
  placeholder,
  w,
  minW,
  maxW,
  invalid,
  required,
  info,
  ...props
}) => {
  const colors = useThemeColors();
  return (
    <Field.Root invalid={invalid} required={required}>
      <Field.Label gap={1}>
        {label}
        <Field.RequiredIndicator />
        <Box
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
          }}
          cursor="help"
        >
          {info}
        </Box>
      </Field.Label>

      <NumberInput.Root
        value={value}
        onValueChange={(details) => onChange(details.value)}
        allowMouseWheel
        min={props.min}
        max={props.max}
        w={w}
        minW={minW}
        maxW={maxW}
      >
        <NumberInput.Control borderColor={colors.border.input} />
        <InputGroup
          startElement={startElement}
          startAddonProps={{ borderColor: colors.border.input }}
          endAddonProps={{ borderColor: colors.border.input }}
        >
          <NumberInput.Input
            placeholder={placeholder}
            borderColor={colors.border.input}
            onBlur={onBlur}
          />
        </InputGroup>
      </NumberInput.Root>
      <Field.ErrorText>{error}</Field.ErrorText>
    </Field.Root>
  );
};

export default CustomNumberInput;
